import { createFileRoute } from '@tanstack/react-router';

import { FiltersSetup } from '@/components/features/data-harmonization/dashboard/graphs/setup/FiltersSetup';
import { DHPageAccessProvider } from '@/components/features/data-harmonization/providers/DHPageAccessProvider';

export const Route = createFileRoute('/_protected/t/$tenantId/data-harmonization/dashboard/$dashboardId/filters-setup')(
  {
    component: RouteComponent,
  },
);

function RouteComponent() {
  const { dashboardId } = Route.useParams();
  return (
    <DHPageAccessProvider permission="page:filters-setup" isLoading={false} dashboardId={dashboardId}>
      <FiltersSetup dashboardId={dashboardId} />
    </DHPageAccessProvider>
  );
}
